import { Transition } from '@headlessui/react';
import { memo, useMemo, useRef } from 'react';
import ImageElementRemoveButton from './ImageElementRemoveButton';
import ImageElementBorderRadiusToggle from './ImageElementBorderRadiusToggle';
import ImageElementFill from './ImageElementFill';
import { ElementTransitionButton } from '../common/ElementTransitionButton';
import { useClipsContext } from '@/context/ClipsContext/ClipsContext';
import { ImageElement } from '@/player-config/src/types/RemotionPlayerConfigTypes/Element/ImageElement';
import { getPlayerConfigElementById } from '@/player-config/src/utils/playerConfigUtils';

function ImageElementMenu({ imageElementId }: { imageElementId: string }) {
  const menuRef = useRef<HTMLDivElement>(null);
  const { clipData } = useClipsContext();

  const selectedElement = useMemo(() => {
    return getPlayerConfigElementById(clipData.asset_metadata.player_config, imageElementId) as ImageElement;
  }, [clipData.asset_metadata.player_config, imageElementId]);

  return (
    <Transition
      appear
      as="div"
      show
      className="z-[60] flex cursor-auto items-center justify-center transition-all duration-100"
      enterFrom="opacity-0 max-h-0"
      enterTo="opacity-100 max-h-96"
      leaveFrom="opacity-100 max-h-96"
      leaveTo="opacity-0 max-h-0"
    >
      <div
        id="image-element-menu"
        className="relative flex space-x-1 rounded-lg border bg-white p-0.5 shadow"
        onPointerDown={e => e.stopPropagation()}
        onClick={e => e.stopPropagation()}
        ref={menuRef}
      >
        <div className="relative z-10">
          <ImageElementFill selectedElement={selectedElement} />
        </div>
        <div className="relative z-10">
          <ImageElementBorderRadiusToggle selectedElement={selectedElement} />
        </div>

        <div className="relative z-10">
          <ElementTransitionButton selectedElement={selectedElement} />
        </div>

        <div className="relative z-10">
          <ImageElementRemoveButton imageElementId={imageElementId} />
        </div>
      </div>
    </Transition>
  );
}

export default memo(ImageElementMenu);
